module.exports = __webpack_public_path__ + "img/arcade.55135966.png";